import React from 'react';
import { PTPApp } from './pages/PTPApp';
export function App() {
  return <div className="min-h-screen w-full bg-black flex items-center justify-center" data-id="element-0">
      {/* Mobile device simulator container */}
      <div className="w-full max-w-[430px] h-[100dvh] md:h-[900px] md:max-h-[95vh] bg-slate-950 md:rounded-[40px] md:border-[8px] border-slate-900 overflow-hidden relative shadow-2xl flex flex-col" data-id="element-1">
        {/* Fake mobile status bar (optional visual polish) */}
        <div className="h-7 w-full bg-slate-950 flex justify-center items-end pb-1 z-50" data-id="element-2">
          <div className="w-1/3 h-1.5 bg-slate-800 rounded-full" data-id="element-3"></div>
        </div>

        {/* Main App */}
        <div className="flex-1 overflow-hidden relative" data-id="element-4">
          <PTPApp data-id="element-5" />
        </div>

        {/* Fake mobile home indicator */}
        <div className="h-6 w-full bg-slate-950 flex justify-center items-center z-50" data-id="element-6">
          <div className="w-1/3 h-1 bg-slate-700 rounded-full" data-id="element-7"></div>
        </div>
      </div>
    </div>;
}